<TextInputStyleProvider><BaseInput v-bind="$attrs" :label="label" :type="InputElementTypes.Email"></BaseInput></TextInputStyleProvider>